/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Update_FailedInputs */

const en_cargo_update_failed = /** @type {(inputs: Cargo_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update cargo`)
};

const es_cargo_update_failed = /** @type {(inputs: Cargo_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo actualizar la carga`)
};

/**
* | output |
* | --- |
* | "Failed to update cargo" |
*
* @param {Cargo_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_update_failed = /** @type {((inputs?: Cargo_Update_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Update_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_update_failed(inputs)
	return es_cargo_update_failed(inputs)
});